<template>
  <div class="page-content">
    <!-- 页面标题区域 -->
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">个人信息完善</span>
      </div>
      <!-- <a href="javascript:void(0)" class="back-link" @click="handleBack"> <em style="position: relative;top: -1px;">&lt;</em> 返回 </a> -->
    </div>
    <div class="newMine_content">
      <!-- 考籍信息 -->
      <div class="section student-info-section">
        <div class="section-title">
          <span class="title-text">考籍信息</span>
        </div>
        <div class="section-content">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名:</span>
            <span class="value">
              {{ studentInfo.name }}
              <span v-if="studentInfo.certiNo" class="ticket-number">
                (准考证{{ studentInfo.certiNo }})
              </span>
            </span>
          </div>
          <div class="info-item">
            <span class="label">性别:</span>
            <span class="value">{{ getGenderLabel(studentInfo.gender) }}</span>
          </div>
          <div class="info-item">
            <span class="label">证件号:</span>
            <span class="value">{{ studentInfo.idCardNumber }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="label">出生日期:</span>
            <span class="value">{{ studentInfo.birthday }}</span>
          </div>
          <div class="info-item">
            <span class="label">准考准号:</span>
            <span class="value">{{ studentInfo.certiNo }}</span>
          </div> -->
          <div class="info-item">
            <span class="label">专业:</span>
            <span class="value">{{ studentInfo.specialtyCode ? studentInfo.specialtyCode + '-' + studentInfo.specialtyName : studentInfo.specialtyName }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业层次:</span>
            <span class="value">{{ studentInfo.eduLevel | f('edulevel') }}</span>
          </div>
          <div class="info-item">
            <span class="label">助学点:</span>
            <span class="value">{{ studentInfo.orgCode ? studentInfo.orgCode + '-' + studentInfo.orgName : studentInfo.orgName }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="label">证件类型:</span>
            <span class="value">{{ getIdTypeLabel(studentInfo.idType) }}</span>
          </div> -->
        </div>
      </div>
        <el-form :model="form" :rules="rules" ref="studentInfoForm" label-width="100px" class="student-info-form" size="small">
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="原专科专业" prop="oldSpecialty">
                <el-input v-model="form.oldSpecialty" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民族" prop="nation">
                <el-select v-model="form.nation" placeholder="请选择" clearable class="full-width">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in nationOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身体状况" prop="bodyCondition">
                <el-input v-model="form.bodyCondition" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户籍地" prop="registerProvince1">
                <el-cascader
                  v-model="registerAddressArr1"
                  :options="addressOptions"
                  :props="cascaderProps"
                  @change="handleAddressChange1"
                  placeholder="请选择"
                  clearable
                  class="full-width"
                >
              </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="政治面貌" prop="politicStatus">
                <el-select v-model="form.politicStatus" placeholder="请选择" clearable class="full-width">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in politicStatusOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="常住地" prop="registerProvince">
                <el-cascader
                  v-model="registerAddressArr"
                  :options="addressOptions"
                  :props="cascaderProps"
                  @change="handleAddressChange"
                  placeholder="请选择省市区"
                  clearable
                  class="full-width"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="通讯地址" prop="contactAddress">
                <el-input v-model="form.contactAddress" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作单位" prop="workUnit">
                <el-input v-model="form.workUnit" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原有学历" prop="oldEducation">
                <el-select v-model="form.oldEducation" placeholder="请选择" clearable class="full-width">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in educationOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职业" prop="job">
                <el-select v-model="form.job" placeholder="请选择" clearable class="full-width">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in jobOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="QQ" prop="qqNum">
                <el-input v-model="form.qqNum" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮编" prop="postalCode">
                <el-input v-model="form.postalCode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 家庭联系人信息 -->
      <div class="section contact-info-section">
        <div class="section-title d-flex d-flex-middle d-flex-between">
          <span class="title-text">家庭联系人信息 (至少填写一位联系人)</span>
          <div class="add-contact-btn-wrapper">
            <el-button
              type="text"
              icon="el-icon-plus"
              @click="handleAddContact"
              class="add-contact-btn"
            >增加联系人</el-button>
          </div>
        </div>
        <div class="contact-content">
          <div
            v-for="(contact, index) in form.contactList"
            :key="index"
            class="contact-row"
          >
            <div class="contact-field-group">
              <span class="contact-label">{{ `联系人${index + 1}:` }}</span>
              <el-input
                v-model="contact.contactName"
                placeholder="请输入"
                clearable
                size="small"
                class="contact-input"
              ></el-input>
            </div>
            <div class="contact-field-group">
              <span class="contact-label">关系:</span>
              <el-input
                v-model="contact.contactRelationship"
                placeholder="请输入"
                clearable
                size="small"
                class="contact-input"
              ></el-input>
            </div>
            <div class="contact-field-group">
              <span class="contact-label">电话:</span>
              <el-input
                v-model="contact.contactPhone"
                placeholder="请输入"
                clearable
                size="small"
                class="contact-input"
              ></el-input>
            </div>
            <div class="contact-actions">
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDeleteContact(index)"
                :disabled="form.contactList.length <= 1"
                class="delete-btn"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 附件信息 -->
      <div class="section attachment-section no-borderB ">
        <div class="section-title">
          <span class="title-text">附件信息</span>
        </div>
        <div class="attachment-content">
          <!-- 第一行：3个上传字段 -->
          <el-row :gutter="20" class="upload-row">
            <el-col :span="8">
              <div class="upload-item">
                <div class="upload-left-content">
                  <div class="upload-label">
                    <span class="required-mark">*</span>身份证人像面:
                  </div>
                </div>
                <div class="upload-right-content">
                  <UploadInfoImage v-model="form.sfzAUrl" width="128px"></UploadInfoImage>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="upload-item">
                <div class="upload-left-content w165">
                  <div class="upload-label">
                    <span class="required-mark">*</span>身份证国徽面:
                  </div>
                </div>
                <div class="upload-right-content">
                  <UploadInfoImage v-model="form.sfzBUrl" width="128px"></UploadInfoImage>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="upload-item">
                <div class="upload-left-content">
                  <div class="upload-label">
                    <span class="required-mark">*</span>电子照片:
                  </div>
                  <div class="upload-tip">(建议尺寸 480*640,大小 20kb~40kb)</div>
                </div>
                <div class="upload-right-content">
                  <UploadInfoImage v-model="form.photo" width="128px"></UploadInfoImage>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 第二行：2个上传字段 -->
          <el-row :gutter="20" class="upload-row upload-row-second">
            <!-- <el-col :span="8">
              <div class="upload-item">
                <div class="upload-left-content">
                  <div class="upload-label">
                    承诺书:
                  </div>
                  <div class="upload-tip">(请下载电子档, 打印填写后拍照上传)</div>
                  <div class="upload-actions">
                    <el-button size="mini" type="text" @click="handleDownloadCommitment" class="download-link">下载承诺书</el-button>
                  </div>
                </div>
                <div class="upload-right-content">
                  <UploadInfoImage v-model="form.promiseNoticeUrl" width="128px"></UploadInfoImage>
                </div>
              </div>
            </el-col> -->
            <el-col :span="8">
              <div class="upload-item">
                <div class="upload-left-content w165">
                  <!-- 20260402马涛说我们不专业，所以要去掉必填 -->
                  <div class="upload-label"><!-- <span class="required-mark">*</span> -->教育部学历证书电子注册备案表:</div>
                  <div class="upload-tip">(登录学信网,选择:学历考籍查询一本人查询一输入用户名密码一在线验证报告一高等学历一申请中文版180天)</div>
                </div>
                <div class="upload-right-content">
                  <UploadInfoImage v-model="form.certificationReportUrl" width="128px"></UploadInfoImage>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 承诺和提交 -->
      <div class="section commitment-section no-borderB ">
        <div class="commitment-text">
          承诺:本人承诺全部注册资料已如实填写,如因填写错误造成的责任由本人自己承担!
        </div>
        <div class="action-buttons d-flex d-flex-middle d-flex-center">
          <el-button type="primary" class="submit-btn" @click="handleSubmit">同意上述承诺并提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import addressData from '@/data/address.js'
import UploadInfoImage from '@/components/UploadInfoImage.vue'

export default {
  name: "bmInfo",
  components: {
    UploadInfoImage
  },
  data () {
    return {
        MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
        loading: false,
        studentInfo: {},
        form: {
            name: '',
            specialty: '',
            oldSpecialty: '',
            bodyCondition: '',
            politicStatus: '',
            contactAddress: '',
            oldEducation: '',
            qqNum: '',
            phone: '',
            gender: '',
            birthday: '',
            idType: '',
            idCardNumber: '',
            nation: '',
            registerProvince1: '',
            registerCity1: '',
            registerRegion1: '',
            registerProvince: '',
            registerCity: '',
            registerRegion: '',
            workUnit: '',
            job: '',
            postalCode: '',
            contactList: [
            {
                contactName: '',
                contactRelationship: '',
                contactPhone: ''
            },
            ],
            sfzAUrl: '',
            sfzBUrl: '',
            photo: '',
            promiseNoticeUrl: '',
            certificationReportUrl: ''
        },
        registerAddressArr: [],
        registerAddressArr1: [],
        addressOptions: [],
        cascaderProps: {
            value: 'code',
            label: 'name',
            children: 'children',
            expandTrigger: 'hover'
        },
        politicStatusOptions: [],
        educationOptions: [],
        nationOptions: [],
        genderOptions: [],
        idTypeOptions: [],
        jobOptions: [],
        rules: {
            oldSpecialty: [
            { required: true, message: '请输入原专科专业', trigger: 'blur' }
            ],
            nation: [
            { required: true, message: '请选择民族', trigger: 'change' }
            ],
            bodyCondition: [
            { required: true, message: '请输入身体状况', trigger: 'blur' }
            ],
            politicStatus: [
            { required: true, message: '请选择政治面貌', trigger: 'change' }
            ],
            contactAddress: [
            { required: true, message: '请输入通讯地址', trigger: 'blur' }
            ],
            oldEducation: [
            { required: true, message: '请选择原有学历', trigger: 'change' }
            ],
            qqNum: [
            { required: true, message: '请输入QQ', trigger: 'blur' }
            ],
            phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
            nation: [
            { required: true, message: '请选择民族', trigger: 'change' }
            ],
            workUnit: [
            { required: true, message: '请输入工作单位', trigger: 'blur' }
            ],
            job: [
            { required: true, message: '请选择职业', trigger: 'change' }
            ],
            postalCode: [
            { required: true, message: '请输入邮编', trigger: 'blur' }
            ],
            registerProvince1: [
            {
                required: true,
                message: '请选择户籍地',
                trigger: 'change',
                validator: (rule, value, callback) => {
                if (!this.form.registerProvince1 || !this.form.registerCity1 || !this.form.registerRegion1) {
                    callback(new Error('请选择完整的省市区'))
                } else {
                    callback()
                }
                }
            }
            ],
            registerProvince: [
            {
                required: true,
                message: '请选择常住地',
                trigger: 'change',
                validator: (rule, value, callback) => {
                if (!this.form.registerProvince || !this.form.registerCity || !this.form.registerRegion) {
                    callback(new Error('请选择完整的省市区'))
                } else {
                    callback()
                }
                }
            }
            ],
            sfzAUrl: [
            { required: true, message: '请上传身份证人像面', trigger: 'change' }
            ],
            sfzBUrl: [
            { required: true, message: '请上传身份证国徽面', trigger: 'change' }
            ],
            photo: [
            { required: true, message: '请上传电子照片', trigger: 'change' }
            ]/* ,
            certificationReportUrl: [
            { required: true, message: '请上传教育部学历证书电子注册备案表', trigger: 'change' }
            ] */
        },
    };
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    // 监听地址选项，当数据加载完成后设置回显
    addressOptions: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.setAddressDisplay()
        }
      },
      immediate: true
    }
  },
  created () {
    // 先加载地址数据，再获取表单数据，确保地址转换功能可用
    this.loadRegionData();
    this.getData();
    this.getDictData();
  },
  methods: {
    async getData () {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
            if(res) {
                // 保存原始代码值（用于级联选择器显示）
                const originalProvince = res.registerProvince
                const originalCity = res.registerCity
                const originalRegion = res.registerRegion
                const originalProvince1 = res.registerProvince1
                const originalCity1 = res.registerCity1
                const originalRegion1 = res.registerRegion1

                // 处理常住地：如果返回的是代码，转换为名称；如果是名称，直接使用
                let registerProvince = res.registerProvince
                let registerCity = res.registerCity
                let registerRegion = res.registerRegion

                // 判断是否为代码（代码通常是数字）
                if (registerProvince && /^\d+$/.test(String(registerProvince))) {
                    registerProvince = this.getAddressName(registerProvince)
                }
                if (registerCity && /^\d+$/.test(String(registerCity))) {
                    registerCity = this.getAddressName(registerCity)
                }
                if (registerRegion && /^\d+$/.test(String(registerRegion))) {
                    registerRegion = this.getAddressName(registerRegion)
                }

                // 处理户籍地：如果返回的是代码，转换为名称；如果是名称，直接使用
                let registerProvince1 = res.registerProvince1
                let registerCity1 = res.registerCity1
                let registerRegion1 = res.registerRegion1

                // 判断是否为代码（代码通常是数字）
                if (registerProvince1 && /^\d+$/.test(String(registerProvince1))) {
                    registerProvince1 = this.getAddressName(registerProvince1)
                }
                if (registerCity1 && /^\d+$/.test(String(registerCity1))) {
                    registerCity1 = this.getAddressName(registerCity1)
                }
                if (registerRegion1 && /^\d+$/.test(String(registerRegion1))) {
                    registerRegion1 = this.getAddressName(registerRegion1)
                }

                // 注意：级联选择器的回显由 watch 中的 setAddressDisplay 方法处理
                // 这里只需要确保 form 中存储的是名称即可

                this.studentInfo = res
                this.form = {
                    ...this.form,
                    ...res,
                    // 使用转换后的名称（用于提交）
                    registerProvince,
                    registerCity,
                    registerRegion,
                    registerProvince1,
                    registerCity1,
                    registerRegion1
                }

                // 数据设置完成后，触发地址回显
                this.$nextTick(() => {
                    this.setAddressDisplay()
                })
            }
        })
    },
    loadRegionData() {
      // 将 addressData 转换为三级结构
      this.addressOptions = addressData.map(province => {
        // 判断是否为直辖市（北京、上海、天津、重庆）
        const isDirectCity = [110000, 120000, 310000, 500000].includes(province.code)
        if (isDirectCity) {
          return {
            code: province.code,
            name: province.name,
            children: [{
              code: province.code,
              name: province.name,
              children: province.children.map(district => ({
                code: district.code,
                name: district.name
              }))
            }]
          }
        } else {
          // 普通省份：省 -> 市 -> 区
          return {
            code: province.code,
            name: province.name,
            children: province.children.map(city => {
              // 如果市有 children（区），使用；否则将市本身作为区
              if (city.children && city.children.length > 0) {
                return {
                  code: city.code,
                  name: city.name,
                  children: city.children.map(district => ({
                    code: district.code,
                    name: district.name
                  }))
                }
              } else {
                // 没有区数据，将市本身作为区
                return {
                  code: city.code,
                  name: city.name,
                  children: [{
                    code: city.code,
                    name: city.name
                  }]
                }
              }
            })
          }
        }
      })
    },
    // 根据地址代码获取地址名称
    getAddressName(code) {
      if (!code) return ''
      // 统一转换为数字进行比较（地址数据中的code是数字类型）
      const codeNum = typeof code === 'string' ? parseInt(code) : code
      if (isNaN(codeNum)) return code

      // 遍历省份
      for (const province of this.addressOptions) {
        if (province.code === codeNum) {
          return province.name
        }
        // 遍历城市
        if (province.children) {
          for (const city of province.children) {
            if (city.code === codeNum) {
              return city.name
            }
            // 遍历区县
            if (city.children) {
              for (const district of city.children) {
                if (district.code === codeNum) {
                  return district.name
                }
              }
            }
          }
        }
      }
      return code
    },
    // 根据地址名称获取地址代码
    getAddressCode(name) {
      if (!name) return ''
      // 如果已经是代码（数字），直接返回
      if (/^\d+$/.test(String(name))) {
        return name
      }

      // 遍历省份
      for (const province of this.addressOptions) {
        if (province.name === name) {
          return province.code
        }
        // 遍历城市
        if (province.children) {
          for (const city of province.children) {
            if (city.name === name) {
              return city.code
            }
            // 遍历区县
            if (city.children) {
              for (const district of city.children) {
                if (district.name === name) {
                  return district.code
                }
              }
            }
          }
        }
      }
      return name
    },
    // 设置地址回显
    setAddressDisplay() {
      // 设置常住地回显
      if (this.form.registerProvince && this.form.registerCity && this.form.registerRegion && this.addressOptions.length > 0) {
        let provinceCode = this.form.registerProvince
        let cityCode = this.form.registerCity
        let regionCode = this.form.registerRegion

        // 如果是名称，转换为代码
        if (!/^\d+$/.test(String(provinceCode))) {
          provinceCode = this.getAddressCode(provinceCode)
        }
        if (!/^\d+$/.test(String(cityCode))) {
          cityCode = this.getAddressCode(cityCode)
        }
        if (!/^\d+$/.test(String(regionCode))) {
          regionCode = this.getAddressCode(regionCode)
        }

        // 如果都转换成功（都是代码），设置级联选择器
        if (/^\d+$/.test(String(provinceCode)) && /^\d+$/.test(String(cityCode)) && /^\d+$/.test(String(regionCode))) {
          this.$nextTick(() => {
            this.registerAddressArr = [provinceCode, cityCode, regionCode]
          })
        }
      }

      // 设置户籍地回显
      if (this.form.registerProvince1 && this.form.registerCity1 && this.form.registerRegion1 && this.addressOptions.length > 0) {
        let provinceCode1 = this.form.registerProvince1
        let cityCode1 = this.form.registerCity1
        let regionCode1 = this.form.registerRegion1

        // 如果是名称，转换为代码
        if (!/^\d+$/.test(String(provinceCode1))) {
          provinceCode1 = this.getAddressCode(provinceCode1)
        }
        if (!/^\d+$/.test(String(cityCode1))) {
          cityCode1 = this.getAddressCode(cityCode1)
        }
        if (!/^\d+$/.test(String(regionCode1))) {
          regionCode1 = this.getAddressCode(regionCode1)
        }

        // 如果都转换成功（都是代码），设置级联选择器
        if (/^\d+$/.test(String(provinceCode1)) && /^\d+$/.test(String(cityCode1)) && /^\d+$/.test(String(regionCode1))) {
          this.$nextTick(() => {
            this.registerAddressArr1 = [provinceCode1, cityCode1, regionCode1]
          })
        }
      }
    },
    handleAddressChange(value) {
      if (value && value.length === 3) {
        // 级联选择器的值（代码）会自动更新到 registerAddressArr
        // 将代码转换为名称存储到 form
        this.form.registerProvince = this.getAddressName(value[0])
        this.form.registerCity = this.getAddressName(value[1])
        this.form.registerRegion = this.getAddressName(value[2])
      } else {
        // 清空时，也要清空 form 中的值
        this.form.registerProvince = ''
        this.form.registerCity = ''
        this.form.registerRegion = ''
        this.registerAddressArr = []
      }
    },
    handleAddressChange1(value) {
      if (value && value.length === 3) {
        // 级联选择器的值（代码）会自动更新到 registerAddressArr1
        // 将代码转换为名称存储到 form
        this.form.registerProvince1 = this.getAddressName(value[0])
        this.form.registerCity1 = this.getAddressName(value[1])
        this.form.registerRegion1 = this.getAddressName(value[2])
      } else {
        // 清空时，也要清空 form 中的值
        this.form.registerProvince1 = ''
        this.form.registerCity1 = ''
        this.form.registerRegion1 = ''
        this.registerAddressArr1 = []
      }
    },
    getDictData() {
      this.$http.post('/student/common/getDictItemByTypes', ['politi_type', 'eduleveles', 'nation', 'gender', 'id_type', 'profession']).then(res => {
        if (res.politi_type) {
          this.politicStatusOptions = res.politi_type
        }
        if (res.eduleveles) {
          this.educationOptions = res.eduleveles
        }
        if (res.nation) {
          this.nationOptions = res.nation
        }
        if (res.gender) {
          this.genderOptions = res.gender
        }
        if (res.id_type) {
          this.idTypeOptions = res.id_type
        }
        if (res.profession) {
          this.jobOptions = res.profession
        }
      }).catch(err => {
        console.error('获取字典数据失败:', err)
      })
    },
    getGenderLabel(value) {
      if (!value) return ''
      const item = this.genderOptions.find(item => item.value === value)
      return item ? item.label : value
    },
    getIdTypeLabel(value) {
      if (!value) return ''
      const item = this.idTypeOptions.find(item => item.value === value)
      return item ? item.label : value
    },
    handleDownloadCommitment() {
      // 下载承诺书
      this.$http.get('/student/pc/getCommitment').then(res => {
        if (res && res.fileList && res.fileList[0] && res.fileList[0].url) {
          const url = decodeURIComponent(res.fileList[0].url)
          const a = document.createElement('a')
          a.href = url
          a.target = '_blank'
          a.download = '承诺书'
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        } else {
          this.$message.info('承诺书为非必填，当前无可下载文件')
        }
      }).catch(err => {
        this.$message.error('下载承诺书失败')
      })
    },
    handleAddContact() {
      // 添加联系人
      this.form.contactList.push({
        contactName: '',
        contactRelationship: '',
        contactPhone: ''
      })
    },
    handleDeleteContact(index) {
      // 删除联系人，至少保留一个
      if (this.form.contactList.length <= 1) {
        this.$message.warning('至少需要保留一位联系人')
        return
      }
      this.$confirm('确定要删除该联系人吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.contactList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {
        // 取消删除
      })
    },
    handleSubmit() {
      const _this = this
      // 验证至少填写一个联系人
      const hasValidContact = this.form.contactList.some(contact =>
        contact.contactName &&
        contact.contactRelationship &&
        contact.contactPhone
      )

      if (!hasValidContact) {
        this.$message.warning('请至少填写一位联系人信息')
        return
      }

      // 验证表单
      this.$refs.studentInfoForm.validate((valid, fields) => {
        if (!valid) {
          this.$nextTick(() => {
            const errorElement = this.$refs.studentInfoForm.$el.querySelector('.el-form-item__error')
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })

          return false
        }

        // 提交数据
        const submitData = {
          ...this.form
        }

        this.loading = true
        this.$http.post(this.MOCK_PREFIX + '/student/pc/studentConfirmInfo', submitData).then((res) => {
          this.loading = false
          this.$message.success('提交成功')
          this.$router.push({ path: '/main/bmRegister' })
        })
      })
    },
    handleBack() {
      this.$router.push({ path: '/main/bmRegister' })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  min-height: 500px;
  padding: 0 30px;
}
.page-header {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0;
  border-bottom: 1px solid #f2f2f2;

  .page-title {
    padding: 0;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
  .back-link {
    color: #767676;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.3s;
  }
}

.newMine_content {
  padding: 30px 0;
}

.section {
  margin-bottom: 30px;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 20px;
  &.no-borderB {
    border-bottom: none;
    padding-bottom: 0;
  }


  .section-title {
    margin-bottom: 20px;
    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }
  .section-content{
    margin-bottom: 30px;
  }
  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px 50px;

    .info-item {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      line-height: 1.6;

      &.full-width {
        grid-column: 1 / -1;
      }

      .label {
        color: #767676;
        margin-right: 10px;
        flex-shrink: 0;
        font-weight: 400;
      }

      .value {
        color: #303133;
        flex: 1;
        word-break: break-all;
        font-weight: 400;

        .ticket-number {
          color: #aaa;
          margin-left: 5px;
        }
      }
    }
  }
}

.student-info-section {
  .student-info-form {
    ::v-deep .el-form-item {
      margin-bottom: 20px;
    }

    ::v-deep .el-form-item__label {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
    }

    .readonly-value {
      color: #303133;
      font-size: 14px;
    }

    .full-width {
      width: 100%;
    }
  }
}

.contact-info-section {
  .contact-content {
    .contact-row {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 15px;
      padding: 8px 0;

      .contact-field-group {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;

        .contact-label {
          font-size: 14px;
          color: #303133;
          min-width: 75px;
          flex-shrink: 0;
          white-space: nowrap;
          text-align: right;
        }

        .contact-input {
          flex: 1;
          min-width: 150px;
        }
      }

      .contact-actions {
        flex-shrink: 0;
        width: 32px;
        display: flex;
        justify-content: center;

        .delete-btn {
          color: #f56c6c;
          padding: 0;
          font-size: 18px;
          line-height: 1;

          &:hover {
            color: #ff7875;
          }

          &:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }
      }
    }

    .add-contact-btn-wrapper {
      margin-top: 5px;
      padding-left: 75px;

      .add-contact-btn {
        color: #4084FF;
        padding: 0;
        font-size: 14px;

        &:hover {
          color: #40a9ff;
        }

        i {
          margin-right: 4px;
        }
      }
    }
  }
}

.attachment-section {
  .attachment-content {
    .upload-row {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

    }

    .upload-item {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      gap: 15px;
      justify-content: flex-start;

      .upload-label {
        font-size: 14px;
        color: #1a1a1a;
        line-height: 1.5;
        min-width: 105px;
        flex-shrink: 0;
        padding-top: 4px;
        text-align: right;


        .required-mark {
          color: #f56c6c;
          margin-right: 4px;
        }
      }

      .upload-tip {
        font-size: 11px;
        color: #4084FF;
        line-height: 1.5;
        word-break: break-all;
        min-width: 105px;
        max-width: 165px;
        flex-shrink: 0;
        text-align: right;
      }

      .upload-actions {
        text-align: right;
        .download-link {
          color: #4084FF;
          font-size: 12px;
          padding: 0;
          text-decoration: underline;
          &:hover {
            color: #40a9ff;
          }
        }
      }

      // 左侧内容区域（标签、提示、操作按钮）
      .upload-left-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 100px;
        flex-shrink: 0;
        gap: 8px;
        justify-content: flex-start;
        align-items: flex-end;
      }

      // 右侧上传区域
      .upload-right-content {
        width: 140px;
        flex-shrink: 0;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        min-width: 0;
      }

      // 确保上传组件正常显示
      ::v-deep .imgUpload {
        width: 130px;
        flex-shrink: 0;

        .avatar-uploader {
          .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 130px;
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              border-color: #409EFF;
            }
          }
        }
      }
    }
  }
}

.commitment-section {
  .commitment-text {
    color: #EA0000;
    font-size: 12px;
    text-align: center;
    margin: 60px auto 20px auto;
    line-height: 1.6;
  }

  .action-buttons {
    .submit-btn {
        width: 196px;
        height: 40px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 10px 10px 10px 10px;
        border: none;
        color: #fff;
        font-size: 14px;
        font-weight: 500;

        &:hover {
            opacity: 0.9;
        }
    }
  }
}
.w165{
    width: 165px !important;
}
 ::v-deep .imgUpload .avatar{
    height: 128px;
    width: 128px;
}
</style>
